import type { Product } from '@/features/products/shared';

/** API interceptor unwraps Axios; tolerate the wrapped response used by callers too. */
export const productResults = (response: { data?: unknown }): Product[] => {
  const data = response?.data;
  if (Array.isArray(data)) return data;
  const nested = data && typeof data === 'object' && 'data' in data ? (data as { data: unknown }).data : null;
  return Array.isArray(nested) ? nested : [];
};

export const suggestionIndex = (active: number, count: number, direction: 'ArrowUp' | 'ArrowDown') => {
  if (!count) return -1;
  if (active < 0) return direction === 'ArrowDown' ? 0 : count - 1;
  return (active + (direction === 'ArrowDown' ? 1 : -1) + count) % count;
};
